import _toConsumableArray from "/Users/amitmarkovich/Desktop/Dev/appsforce/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export default function removeClasses() {
  var _el$classList;

  var swiper = this;
  var el = swiper.el,
      classNames = swiper.classNames;

  (_el$classList = el.classList).remove.apply(_el$classList, _toConsumableArray(classNames));

  swiper.emitContainerClasses();
}